import React from 'react';

export const ExclamationMarkSvg = (props) => {

  const { width, height, color } = props;

  return (
    <svg width={width ?? "18"} height={height ?? "18"} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_12756_23769)">
        <path d="M9.35937 16.0723C13.2669 16.0723 16.4346 12.9046 16.4346 8.99707C16.4346 5.08955 13.2669 1.92188 9.35937 1.92188C5.45185 1.92188 2.28418 5.08955 2.28418 8.99707C2.28418 12.9046 5.45185 16.0723 9.35937 16.0723Z" fill={color ?? "#04333B"} />
        <path d="M9.35938 6.17188V9.00195" stroke="white" strokeWidth="1.41504" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9.35938 11.8281H9.36551" stroke="white" strokeWidth="1.41504" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <filter id="filter0_d_12756_23769" x="0.869141" y="0.507812" width="16.9805" height="16.9766" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
          <feOffset />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.113725 0 0 0 0 0.741176 0 0 0 0 0.419608 0 0 0 1 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_12756_23769" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_12756_23769" result="shape" />
        </filter>
      </defs>
    </svg>
  )
}